import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ADSENSE_SCRIPT_ID = "google-adsense-script";

const normalizePublisherId = (value = "") => {
  return String(value).trim().replace(/\s+/g, "");
};

const isValidPublisherId = (value) => {
  return /^ca-pub-\d{16}$/.test(value);
};

const AdSenseScript = () => {
  const location = useLocation();

  useEffect(() => {
    const adsEnabled = process.env.REACT_APP_ADSENSE_ENABLED === "true";
    const publisherId = normalizePublisherId(process.env.REACT_APP_ADSENSE_CLIENT);

    if (!adsEnabled) {
      return;
    }

    if (!isValidPublisherId(publisherId)) {
      console.warn("AdSense is enabled, but REACT_APP_ADSENSE_CLIENT is invalid.");
      return;
    }

    const pathname = location.pathname.toLowerCase();

    // 1. WHITELIST APPROACH: Only load Auto Ads on valid, content-heavy public pages
    const exactAllowedPaths = [
      "/",
      "/about",
      "/contact",
      "/privacy-policy",
      "/disclaimer",
      "/editorial-policy",
      "/corrections-policy"
    ];

    const isAllowedPath =
      exactAllowedPaths.includes(pathname) ||
      pathname.startsWith("/category/") ||
      pathname.startsWith("/post/");

    // Blocks execution on /admin, /login, /search, and any undefined 404 routes
    if (!isAllowedPath) {
      return;
    }

    if (document.getElementById(ADSENSE_SCRIPT_ID)) {
      return;
    }

    const script = document.createElement("script");
    script.id = ADSENSE_SCRIPT_ID;
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(
      publisherId
    )}`;
    script.setAttribute("data-ad-client", publisherId);

    script.onerror = () => {
      console.error("Google AdSense script failed to load.");
    };

    document.head.appendChild(script);
  }, [location.pathname]);

  return null;
};

export default AdSenseScript;